import React from 'react';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
const cityData = [{
  city: 'New York City',
  state: 'NY',
  slug: 'new-york-city',
  count: '3,450'
}, {
  city: 'Atlanta',
  state: 'GA',
  slug: 'atlanta',
  count: '1,680'
}, {
  city: 'Los Angeles',
  state: 'CA',
  slug: 'los-angeles',
  count: '2,890'
}, {
  city: 'Dallas',
  state: 'TX',
  slug: 'dallas',
  count: '1,050'
}, {
  city: 'Houston',
  state: 'TX',
  slug: 'houston',
  count: '1,850'
}, {
  city: 'Miami',
  state: 'FL',
  slug: 'miami',
  count: '1,320'
}, {
  city: 'Chicago',
  state: 'IL',
  slug: 'chicago',
  count: '2,120'
}, {
  city: 'Seattle',
  state: 'WA',
  slug: 'seattle',
  count: '710'
}, {
  city: 'Phoenix',
  state: 'AZ',
  slug: 'phoenix',
  count: '1,420'
}, {
  city: 'San Diego',
  state: 'CA',
  slug: 'san-diego',
  count: '1,090'
}];
export function AccountingCityLinks() {
  return <section className="py-24 bg-slate-50" data-id="element-225">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-226">
        <div className="mb-12" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" data-id="element-228">
            <span className="text-blue-600" data-id="element-229">Industry contact lists</span>{' '}
            <span className="text-slate-900" data-id="element-230">by city</span>
          </h2>
          <p className="text-lg text-slate-500 max-w-3xl" data-id="element-231">
            Browse company email and phone list by location. Choose a city to
            get a targeted database for your outreach.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-232">
          {cityData.map(item => <a key={`${item.city}-${item.state}`} href={item.slug === 'new-york-city' ? '#/data/accounting-new-york-city' : `https://www.openmart.com/data/accounting-${item.slug}`} className="group bg-white border border-slate-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-sm transition-all" data-id="element-233">
              <div className="flex items-center gap-2 mb-3" data-id="element-234">
                <MapPinIcon className="w-4 h-4 text-slate-400 group-hover:text-blue-500 transition-colors flex-shrink-0" data-id="element-235" />
                <h3 className="font-semibold text-slate-900 text-sm" data-id="element-236">
                  {item.city}, {item.state}
                </h3>
              </div>

              <div className="flex items-end justify-between" data-id="element-237">
                <div data-id="element-238">
                  <div className="text-xl font-bold text-blue-600" data-id="element-239">
                    {item.count}
                  </div>
                  <div className="text-xs font-medium text-slate-500" data-id="element-240">
                    Verified firms
                  </div>
                </div>
                <div className="w-7 h-7 rounded-full bg-slate-50 flex items-center justify-center group-hover:bg-blue-600 transition-colors" data-id="element-241">
                  <ArrowRightIcon className="w-3.5 h-3.5 text-slate-400 group-hover:text-white transition-colors" data-id="element-242" />
                </div>
              </div>
            </a>)}
        </div>

        <div className="mt-8 text-center" data-id="element-243">
          <p className="text-sm text-slate-500" data-id="element-244">
            * Counts represent estimated verified accounting owner contacts
            currently available in the database
          </p>
        </div>
      </div>
    </section>;
}